__turbopack_context__.v({
  "SortableDropInto": "Sortable-module-scss-module__h1fCHW__SortableDropInto",
  "draggable": "Sortable-module-scss-module__h1fCHW__draggable",
  "handle": "Sortable-module-scss-module__h1fCHW__handle",
  "handleDisabled": "Sortable-module-scss-module__h1fCHW__handleDisabled",
});
